import React from 'react';
import cls from 'classnames';

import styles from './Shards.module.scss';

interface ShardsProps {
  count?: number;
  explode?: boolean;
}

const calculateStyles = (count: number, index: number, explode = false) => ({
  left: `calc(${index} * ${Math.trunc(100 / count)}% + 1%)`,
  transform: `rotate(${Math.floor(Math.random() * 161) - 80}deg)`,
  animationDelay: explode ? '0ms' : `${Math.floor(Math.random() * 451 + 100)}ms`,
  animationDuration: `${Math.floor(Math.random() * 2500) + 700}ms`,
});

export default function Shards({ count = 25, explode = false }: ShardsProps) {
  const shardCls = React.useMemo(
    () =>
      cls(styles['shard'], {
        ['shard--explode']: explode,
      }),
    [explode],
  );

  return (
    <div className='w-full h-full absolute'>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={'shard_' + index}
          style={{ ...calculateStyles(count, index, explode) }}
          className={shardCls}
        />
      ))}
    </div>
  );
}
